/**
 * @file a utility file to standardise all string normalisation functions in the project.
 *       the functions enforce the use of valid characters and return cleaned lower-case strings
 * @author Paul Mallinson <paul.mallinson@capiche-limited.com>
 * @copyright Copyright (c) 2024 Capiche Limited
 */

import {
  INVALID_GRAPHEME_REGEX,
  createCombiningDiacriticsRe,
  createApostropheRe,
  createHyphenRe,
} from './data-model.regexp';

/**
 * Removes all characters not in the validGraphemes list.
 * normalise, remove any accents, force lower-case, drop anything invalid
 * @param input - The string to be cleaned.
 * @returns The cleaned string.
 */
// TODO: review naming of function...
export function keyOf(input: string): string {
  return input
    .normalize('NFKD') // normalize to decompose combined characters
    .replace(createCombiningDiacriticsRe(), '') // strip accents
    .toLowerCase() // dictionary is all lower case
    .replace(INVALID_GRAPHEME_REGEX, ''); // drop everything not in validGraphemes
}

/**
 * Standardise the characeters in the string (preserves case by default).
 * removes accents, standardises apostrophie and hyphens
 * @param input - The string to be cleaned.
 * @param forceLowerCase - force lower-case output (default: false).
 * @returns The cleaned string.
 */
export function normalOf(input: string, forceLowerCase: boolean = false): string {
  const output: string = input
    .normalize('NFKD') // normalize to decompose combined characters
    .replace(createCombiningDiacriticsRe(), '') // strip accents
    .replace(createApostropheRe(), "'") // apostrophes → '
    .replace(createHyphenRe(), '-'); // hyphens → -
  return forceLowerCase ? output.toLowerCase() : output;
}
